var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ELSTokenHelper, ELSTokenServiceRegistrar } from '@els/els-ui-common-react';
import { refreshToken } from 'services/app-linking.service';
/** DOM events used to detect user activity */
export var IDLE_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
/** Time (ms) before session expiry at which the warning popup appears for inactive users */
export var WARNING_TIME = 5 * 60 * 1000;
/** Minimum interval (ms) between activity-tracking events */
export var ACTIVITY_THROTTLE_MS = 1000;
/** Interval (ms) at which App polls for the JWT token after login */
export var TOKEN_POLL_INTERVAL_MS = 2000;
/**
 * Reads the JWT token's `exp` claim and returns the absolute expiry time in ms.
 * Returns `0` if no token is available or if parsing fails (no fallback).
 */
export var getTokenExpiresAt = function () {
    try {
        var rawToken = ELSTokenHelper.getToken();
        if (!rawToken) {
            return 0;
        }
        var token = ELSTokenHelper.parseToken(rawToken);
        var expMs = (token === null || token === void 0 ? void 0 : token.exp) ? token.exp * 1000 : null;
        if (expMs) {
            return expMs;
        }
    }
    catch (_a) {
        // token parse error – treat as no token
    }
    return 0;
};
/**
 * Refreshes the session token, stores it, and returns the new expiry time in ms.
 * Throws on failure (caller should handle the error).
 */
export var refreshAndGetExpiry = function () { return __awaiter(void 0, void 0, Promise, function () {
    var response, newToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, refreshToken()];
            case 1:
                response = _a.sent();
                newToken = response.data.token;
                ELSTokenHelper.storeToken(newToken);
                ELSTokenServiceRegistrar.register(newToken);
                return [2 /*return*/, getTokenExpiresAt()];
        }
    });
}); };
